import CheckIcon from '@mui/icons-material/Check';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Box, Grid, Paper, RadioGroup, Typography, useMediaQuery } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import ReactPlayer from "react-player";
import { useLocation, useNavigate } from "react-router-dom/dist";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';
import CoreHttpHandler from "../../http/services/CoreHttpHandler";
import { ToastAlertError } from "../../reauseble";
import PageHeader from "../components/PagesHeaderComponent/PageHeader";
import RegisterModal from "../components/RegisterModalComponent/RegisterModal";


const CourseInfo = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const isSmallScreen = useMediaQuery('(max-width:768px)');

	const [modalShow, setModalShow] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [quizData, setQuizData] = useState([]);
	const [selectedAnswers, setSelectedAnswers] = useState({});
	const [isCorrect, setIsCorrect] = useState(0);
	const [quizResult, setQuizResult] = useState({});
	const [quizCertificateLoad, setQuizCertificateLoad] = useState(false);
	const [modalVideoShow, setModalVideoShow] = useState(false);
	const [videoUrl, setVideoUrl] = useState("");
	const [watchedVideo, setWatchedVideo] = useState(false);
	const [isExistingUser, setIsExistingUser] = useState(false);

	const { video_link, picture, learning_objectives, module, short_description, dt, certificate_img } = location.state;


	let userDetails = JSON.parse(localStorage.getItem("user_details"));

	const downloadCertificate = () => {
		let userToken = localStorage.getItem("token");
		if (userToken) {
			// window.open("https://pdfobject.com/pdf/sample.pdf");
			setIsLoading(true)
			CoreHttpHandler.request(
				"shareholder_education",
				"fetchQuizzes",
				{
					"status": true,
					"limit": 6,
					"page": 1,
					course_id: location.state.id

				},
				(res) => {
					if (res.data.data.quizzes.quizzes && res.data.data.quizzes.quizzes.length) {

						setQuizData(res.data.data.quizzes.quizzes)
						setIsLoading(false)

					} else {

						// window.open("https://pdfobject.com/pdf/sample.pdf");
						setIsLoading(true)
						CoreHttpHandler.request(
							"shareholder_education",
							"generateCertificate",
							{
								course_id: location.state.id,
								user_name: `${userDetails.first_name} ${userDetails.last_name}`,
								// user_name: userDetails.username,
								course_name: location.state.module

							},
							(res) => {
								// window.open(res.data.data.certificate);
								setIsLoading(true)
								fetch(res.data.data.certificate)
									.then(response => response.blob()) // Fetch the JPG as a Blob
									.then(blob => {
										// Create a URL for the blob
										const url = window.URL.createObjectURL(new Blob([blob]));

										// Create an invisible link element
										const link = document.createElement("a");
										link.href = url;
										link.setAttribute("download", "downloaded-file.jpg"); // Set the downloaded file name

										// Append to the document, trigger click and remove link
										document.body.appendChild(link);
										link.click();
										link.parentNode.removeChild(link);
										setIsLoading(false)
									})
									.catch(error => console.error("Error downloading the JPG:", error));
							},
							(err) => {
								ToastAlertError(
									err?.response?.data?.message
										? err?.response.data.message
										: "something went wrong"
								);
							}
						);
					}
				},
				(err) => {
				}
			);
		} else {
			setModalShow(true)
		}

	}


	const handleAnswerChange = (questionId, answer) => {
		setSelectedAnswers((prevAnswers) => ({
			...prevAnswers,
			[questionId]: answer,
		}));
	};

	const handleSubmit = () => {
		// Logic to handle quiz submission and scoring
		const unansweredQuestions = quizData.some((question) => !selectedAnswers[question.id]);

		if (unansweredQuestions) {
			ToastAlertError("Please answer all questions before submitting!");
			return;
		} else {
			// selected_answers
			setIsLoading(true)
			CoreHttpHandler.request(
				"shareholder_education",
				"generateQuizResult",
				{
					selected_answers: selectedAnswers,
					course_id: location.state.id,
					customer_id: userDetails.id
				},
				(res) => {
					const result = res.data.data.result;
					setQuizResult({
						correctAns: result.correctAnswersCount,
						obt_marks: result.obtainedMarks,
						percentage: result.percentage,
						status: result.status,
						totalQs: result.totalQuestions,
						wrongAns: result.wrongAnswersCount
					})
					setIsLoading(false)
					// ToastAlertSuccess("Item removed Successfully");
				},
				(err) => {
					// ToastAlertError(
					// 	err?.response?.data?.message
					// 		? err?.response.data.message
					// 		: "something went wrong"
					// );
				}
			);
		}
	};


	const downloadQuizCertificate = () => {
		// Logic to handle quiz submission and scoring
		setQuizCertificateLoad(true)
		CoreHttpHandler.request(
			"shareholder_education",
			"generateCertificate",
			{
				course_id: location.state.id,
				user_name: `${userDetails.first_name} ${userDetails.last_name}`,
				course_name: location.state.module

			},
			(res) => {
				// window.open(res.data.data.certificate);
				setQuizCertificateLoad(true)
				fetch(res.data.data.certificate)
					.then(response => response.blob()) // Fetch the PDF as a Blob
					.then(blob => {
						// Create a URL for the blob
						const url = window.URL.createObjectURL(new Blob([blob]));

						// Create an invisible link element
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute("download", "downloaded-file.jpg"); // Set the downloaded file name

						// Append to the document, trigger click and remove link
						document.body.appendChild(link);
						link.click();
						link.parentNode.removeChild(link);
						setQuizCertificateLoad(false)
					})
					.catch(error => console.error("Error downloading the JPG:", error));
			},
			(err) => {
				ToastAlertError(
					err?.response?.data?.message
						? err?.response.data.message
						: "something went wrong"
				);
			}
		);
	};
	const checkExistingUser = () => {

		CoreHttpHandler.request(
			"shareholder_education",
			"checkUser",
			{
				course_id: location.state.id,
				customer_id: userDetails.id

			},
			(res) => {
				setIsExistingUser(res.data.data.result)

			},
			(err) => {
				ToastAlertError(
					err?.response?.data?.message
						? err?.response.data.message
						: "something went wrong"
				);
			}
		);
	};

	const handleWatchVideoBtn = () => {
		setModalVideoShow(true);
		setVideoUrl(video_link);
		setWatchedVideo(true);
	}

	useEffect(() => {
		if(userDetails){
			checkExistingUser();
		}
	}, [userDetails])

	return (
		<>
			<PageHeader heading={location.state.module} />
			<div className="content_wrap">

				<section className='course-info'>


					{quizData?.length && !Object.keys(quizResult).length > 0 ?
						<Container>

							<Row>
								<Col xs={0} lg={1}></Col>
								<Col xs={12} lg={10}>
									<Paper elevation={3} sx={{ padding: 4, marginTop: 4 }}>
										<Typography variant="h3" gutterBottom>
											Quiz
										</Typography>
										{quizData?.map((val) => {
											return <>
												<Typography sx={{ margin: "1em 0 10px 0" }} variant="h5" gutterBottom>
													{val.question}
												</Typography>
												<RadioGroup
													value={selectedAnswers[val.id] || ''}
													onChange={(event) => handleAnswerChange(val.id, event.target.value)}
												>
													<Grid container spacing={2}>
														{val.answers?.map((option, index) => {
															return <>
																<Grid
																	item
																	xs={12}
																	md={6}
																	spacing={2}
																	rowSpacing={2}
																	alignItems="center"
																	key={option.answer_id}
																	onClick={() => handleAnswerChange(val.id, option.answer_id)} // Clicking row selects radio
																>
																	<Grid sx={{ padding: '10px 12px', cursor: 'pointer', backgroundColor: selectedAnswers[val.id] === option.answer_id ? 'rgba(0, 123, 255, 0.1)' : 'rgb(238 249 240)', borderRadius: "5px" }} container alignItems="center" justifyContent="space-between">
																		<Typography variant="body1" align="left">{index + 1}.</Typography>

																		<Typography variant="body1">
																			{option.text}
																		</Typography>
																		{/* <Radio
																			checked={selectedAnswers[val.id] === option.answer_id}
																		/> */}
																		{selectedAnswers[val.id] === option.answer_id ?
																			<CheckIcon />
																			: <RadioButtonUncheckedIcon />
																		}

																	</Grid>
																</Grid>
															</>
														})}
													</Grid>
												</RadioGroup>

												{/* {isSubmitted && (
													<Box mt={2}>
														{isCorrect ? (
															<Typography variant="h6" color="green">
																Correct! 🎉
															</Typography>
														) : (
															<Typography variant="h6" color="red">
																Wrong! The correct answer is Paris.
															</Typography>
														)}
													</Box>
												)} */}
											</>
										})}
										<Box mt={2} display={"flex"} justifyContent="flex-end">
											<button
												className="rounded_btn"
												// variant="contained"
												// color="primary"
												onClick={handleSubmit}
											>
												Submit
											</button>
										</Box>
									</Paper>

								</Col>
								<Col xs={0} lg={1}></Col>
							</Row>

							{/* <Row>
								<Col xs={12}>
									{quizData?.map((val) => {
										return <>
											<h1>{val.question}</h1>
											{val.answers?.map((e) => {
												return <>
													<h1>{e.text}</h1>
													<h1>{e.text}</h1>

												</>
											})}
										</>
									})}



								</Col>
							</Row> */}

						</Container>

						:
						quizResult && Object.keys(quizResult).length > 0 ?
							<Container style={{ m: "auto", background: "#f8f8f8", width: isSmallScreen ? "100%" : "50%", textAlign: "center", padding: "2em", borderRadius: "2em", overflowY: "auto" }}>
								<Typography variant="h1" gutterBottom>
									{quizResult?.percentage}%
								</Typography>
								<Typography sx={{ fontWeight: "bold", marginBottom: "1em" }} variant={isSmallScreen ? "h3" : "h2"} gutterBottom>
									{quizResult?.status === "Pass" &&
										"Congratulations!🎉"
									}
									<div style={{ fontWeight: "normal", marginTop: "15px" }}>
										{quizResult?.status === "Pass" ? "You've Successfully Passed!" :
											"Try Again!"}
									</div>
								</Typography>
								<Typography variant="h4" gutterBottom>
									Total Questions: {quizResult?.totalQs}
								</Typography>

								<Box class="flex_btw">
									<Typography variant="h4" sx={{ color: "green" }} gutterBottom>
										Correct Answers: {quizResult?.correctAns}
									</Typography>
									<Typography variant="h4" color="error" gutterBottom>
										Wrong Answers: {quizResult?.wrongAns}
									</Typography>
								</Box>
								{quizResult?.status === "Pass" &&
									<button className="rounded_btn btn2" onClick={downloadQuizCertificate} >{quizCertificateLoad ? <CircularProgress style={{ 'color': 'white' }} /> : "Download Certificate"}</button>
								}
							</Container>
							:
							<Container>

								<Row>
									<Col xs={12} md={5} lg={6}>
										<img
											style={{ maxWidth: "100%", height: "300px", margin: "auto" }}
											src={picture}
										/>
									</Col>

									<Col xs={0} md={0} lg={1}></Col>


									<Col xs={12} md={7} lg={5} className="module-card" >
										<h4 className="bold">What you'll learn</h4>
										<td dangerouslySetInnerHTML={{ __html: learning_objectives }} />
									</Col>
								</Row>
								{/* <Box className="module_head">
									<h4 className="bold">Modules</h4>
								</Box> */}
								<Row style={{ marginTop: "2em" }}>
									{/* <Col xs={12} md={5} lg={6} className="module-card" >
										<h4 className="bold">What you'll learn</h4>
										<td dangerouslySetInnerHTML={{ __html: learning_objectives }} />
									</Col> */}
									<Col xs={12} md={5} lg={6} className="details-card" style={{ flexDirection: "column", display: "flex", justifyContent: "space-between" }}>

										<h5>{module}</h5>
										<p>{short_description}</p>
										{/* <h6 className="bold">Date / Time</h6>
										<h6>{moment(dt).format("DD-MM-YYYY")}</h6>
										<h6>{moment(dt).format("HH:mm:ss")}</h6> */}
										<div className="btns flex_btw">
											{/* <button className="rounded_btn" >ENROL FOR FREE</button> */}
											{isExistingUser == 1 ?

												<button className="rounded_btn btn2" onClick={downloadQuizCertificate}>Download Certificate</button>
												:
												<button className="rounded_btn btn2" disabled={!certificate_img || !watchedVideo} onClick={downloadCertificate} >{isLoading ? <CircularProgress style={{ 'color': 'white' }} /> : "Get Certificate"}</button>
											}
											{/* <button className="rounded_btn btn2" >Email Me Info</button> */}
										</div>

									</Col>

									<Col xs={0} md={0} lg={1}></Col>

									<Col xs={12} md={7} lg={5} style={{ border: "3px solid #f0f0f8", padding: "15px", borderRadius: "1em" }}>
										{/* <ReactPlayer url={video_link} width="100%" style={{ maxHeight: "500px" }} /> */}
										<div style={{ position: 'relative', width: '100%', height: '200px' }}>
											<ReactPlayer
												url={video_link}
												width="100%"
												height="100%"
												config={{
													youtube: {
														playerVars: {
															controls: 0, // Try to hide YouTube controls
														},
													},
												}}
											/>
											<div
												style={{
													position: 'absolute',
													top: 0,
													left: 0,
													width: '100%',
													height: '100%',
													backgroundColor: 'rgba(255, 255, 255, 0)', // Transparent overlay
													cursor: 'not-allowed', // Change cursor to indicate it's unclickable
												}}
											/>
										</div>

										<button className="rounded_btn" style={{ width: "100%", marginTop: "1em" }} disabled={!video_link} onClick={handleWatchVideoBtn}>Watch Video</button>
									</Col>

								</Row>

							</Container>

					}
				</section>



				<RegisterModal
					modalShow={modalShow}
					setModalShow={setModalShow}
				/>
				<Modal backdrop="static"
					centered
					dialogClassName="modal-90w"
					keyboard={false}
					show={modalVideoShow}
					onHide={() => setModalVideoShow(false)}
					aria-labelledby="contained-modal-title-vcenter">
					<Modal.Header className="modal-bg" closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Video
						</Modal.Title>
					</Modal.Header>
					<Modal.Body className="grid-example modal-bg">
						<Container>

							<ReactPlayer controls url={videoUrl} width="100%" style={{ minHeight: "60vh", maxHeight: "80vh" }} />

						</Container>
					</Modal.Body>
				</Modal>
			</div>

		</>
	);
};

export default CourseInfo;
